import { render, staticRenderFns } from "./MenuTextAlignJustifyButton.vue?vue&type=template&id=7aef03f4&"
import script from "./MenuTextAlignJustifyButton.vue?vue&type=script&lang=ts&"
export * from "./MenuTextAlignJustifyButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports